import React, { useState, useEffect } from "react";
import Navbar from "../header/Navbar";
import Sidebar from "../sidebar/Sidebar";
import "../appointment/style.css";
import "./style.css";
import { Doughnut, Line } from "react-chartjs-2";
import { useLocation, useNavigate } from "react-router-dom";
import {
  getGroupAssesmentScore,
  getGroupAssesmentScoreGraph,
  getGroupbyId,
  getGroupPostsService,
  updateGroupService,
} from "../../services/GroupService";
import GroupActivitiesCard from "../groups/ui/GroupActivitiesCard";
import PostSection from "../groups/ui/PostSection";
import { FiPlusCircle } from "react-icons/fi";
import GroupActivityButtonList from "../groups/ui/GroupActivityButtonList";
import GroupActivityButton from "../groups/ui/GroupActivityButton";
import AddPostModal from "../groups/AddPostModal";
import AddMemberModal from "../groups/AddMemberModal";
import { showToastError, showToastSuccess } from "../../Utils/Helper";
import { toastMsg } from "../../Utils/AllConstant";
import ViewCareteamMemberGroup from "./ViewCareteamMemberGroup";
import GroupActivity from "../groups/ui/assets/groupActivity.png";
import { format } from "date-fns";
import { getDoctors } from "../../services/DoctorService";

const ViewGroupDetails = () => {
  const [modalShow, setModalShow] = useState(false);
  const [listTabs, setListTabs] = useState({
    active: true,
    archived: false,
  });
  const navigate = useNavigate();
  const location = useLocation();
  const state = location.state;
  const [isLoading, setLoader] = useState(true);
  const [posts, setPosts] = useState([]);
  const [selectedGroup, setSelectedGroup] = useState([]);
  const [selectedGroupAssesment, setSelectedGroupAssesment] = useState([]);
  const [selectedGroupAssesmentGraph, setSelectedGroupAssesmentGraph] =
    useState([]);
  const [selectedGroupMembers, setSelectedGroupMembers] = useState([]);
  const [selectedGroupID, setSelectedGroupID] = useState();
  const [careTeamList, setCareTeamList] = useState([]);

  useEffect(() => {
    if (state) {
      setListTabs({
        active: true,
        archived: false,
      });
      getGroupDetails();
      getCareTeamList();
      getGroupAssesmentScoreById();
      getGroupAssesmentScoreGraphById();
      // if (selectedGroup._id) getGroupPosts();
      getGroupPosts();
      setSelectedGroupID(state.selectedGroup._id);
    } // eslint-disable-next-line
  }, [state.selectedGroup, selectedGroupID]);

  const getGroupDetails = async () => {
    try {
      const response = await getGroupbyId(state.selectedGroup._id);
      if (response.status === 200) {
        // console.log(response.data.data, "response");
        setSelectedGroup(response?.data?.data[0]);
      }
    } catch (error) {
      // setLoader(false);
      console.log(error);
    }
  };

  const getCareTeamList = async () => {
    try {
      const response = await getDoctors();
      if (response.status === 200) {
        const filteredCareteamMember = response?.data?.data.filter((doctor) =>
          selectedGroup.careTeamMembers.includes(doctor._id)
        );
        setCareTeamList(filteredCareteamMember);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const getGroupAssesmentScoreById = async () => {
    if (!state.isFromCreate) {
      try {
        const response = await getGroupAssesmentScore(state.selectedGroup._id);
        if (response.status === 200) {
          // console.log(response.data.data, "response");
          setSelectedGroupAssesment(response?.data?.data);
        }
      } catch (error) {
        // setLoader(false);
        console.log(error);
      }
    }
  };

  const getGroupAssesmentScoreGraphById = async () => {
    if (!state.isFromCreate) {
      try {
        const response = await getGroupAssesmentScoreGraph(
          state.selectedGroup._id
        );
        if (response.status === 200) {
          // console.log(response.data.data, "response");
          setSelectedGroupAssesmentGraph(response?.data?.data);
        }
      } catch (error) {
        // setLoader(false);
        console.log(error);
      }
    }
  };

  const getGroupPosts = async () => {
    try {
      const response = await getGroupPostsService(state.selectedGroup._id);
      setLoader(false);
      console.log(response);
      if (response) {
        setPosts(response);
      }
    } catch (error) {
      setPosts([]);
      console.log(error);
      setLoader(false);
    }
  };

  const doughOptions = {
    responsive: true,
    plugins: {
      legend: {
        display: false,
        labels: {
          usePointStyle: true,
          pointStyle: "circle",
        },
      },
      tooltip: {
        enabled: selectedGroupAssesment.length !== 0 ? true : false,
      },
    },
  };

  const data = () => {
    return {
      labels:
        selectedGroupAssesment.length !== 0 &&
        Object.keys(selectedGroup).length > 0
          ? [
              "Nutrition",
              "Stress",
              "Hormonal health",
              "Immune health",
              "Food metabolism",
              "Toxic Exposures",
            ]
          : ["", "", ""],
      datasets: [
        {
          label: "# of Votes",
          data:
            selectedGroupAssesment.length !== 0 &&
            Object.keys(selectedGroup).length > 0
              ? selectedGroupAssesment.map((dt) => dt.points)
              : [33, 33, 33],
          backgroundColor: [
            "rgb(255, 99, 132)",
            "rgb(54, 162, 235)",
            "rgb(255, 206, 86)",
            "rgb(75, 192, 192)",
            "rgb(153, 102, 255)",
            "rgb(255, 159, 64)",
          ],

          borderWidth: 0,
        },
      ],
    };
  };

  const dataLine = () => {
    const monthObj = {
      1: "Jan",
      2: "Feb",
      3: "Mar",
      4: "Apr",
      5: "May",
      6: "Jun",
      7: "Jul",
      8: "Aug",
      9: "Sep",
      10: "Oct",
      11: "Nov",
      12: "Dec",
    };

    const resObj = {
      Jan: 0,
      Feb: 0,
      Mar: 0,
      Apr: 0,
      May: 0,
      Jun: 0,
      Jul: 0,
      Aug: 0,
      Sep: 0,
      Oct: 0,
      Nov: 0,
      Dec: 0,
    };

    selectedGroupAssesmentGraph.map(
      (dt) => (resObj[monthObj[dt.month]] = dt.average)
    );
    // console.log(selectedGroupAssesmentGraph)
    return {
      labels:
        selectedGroupAssesment.length !== 0 &&
        Object.keys(selectedGroup).length > 0
          ? Object.keys(resObj)
          : ["Jan", "Feb"],
      datasets: [
        {
          label: "Average",
          data:
            selectedGroupAssesment.length !== 0 &&
            Object.keys(selectedGroup).length > 0
              ? Object.values(resObj)
              : [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
          fill: true,
          backgroundColor: "rgba(75,192,192,0.2)",
          borderColor: "rgba(75,192,192,1)",
        },
      ],
    };
  };

  const updateGroup = async () => {
    try {
      const response = await updateGroupService(selectedGroupID, {
        ...selectedGroup,
        groupMembers: [...selectedGroup?.groupMembers, ...selectedGroupMembers],
      });
      if (response) {
        showToastSuccess(toastMsg.updateGroup);
        // props.onRefresh()
        setSelectedGroupMembers([]);
        getGroupDetails();
      }
      setLoader(false);
    } catch (error) {
      setLoader(false);
      showToastError(error);
    }
  };
  console.log(posts);
  console.log(selectedGroup);
  return (
    <>
      <Navbar />

      <div className="container-fluid mb-5">
        <div className="row">
          <div className="col-md-2">
            <Sidebar />
          </div>
          <div className="col-md-10 py-4 px-5">
            {/* <nav aria-label="breadcrumb">
              <ol class="breadcrumb">
                <li
                  class="breadcrumb-item cursor-pointer"
                  onClick={() => navigate(-1)}
                >
                  Dashboard
                </li>
                <li class="breadcrumb-item active fw-bold" aria-current="page">
                  Details
                </li>
              </ol>
            </nav> */}
            <nav aria-label="breadcrumb">
              <ol class="breadcrumb">
                <li
                  class="breadcrumb-item cursor-pointer"
                  onClick={() => navigate("/")}
                >
                  Home
                </li>
                <li
                  class="breadcrumb-item active fw-bold cursor-pointer"
                  onClick={() => navigate("/viewcarteamgroups")}
                  aria-current="page"
                >
                  Groups
                </li>
                <li class="breadcrumb-item active fw-bold" aria-current="page">
                  {state.selectedGroup?.groupName}
                </li>
              </ol>
            </nav>

            {/* new Component */}
            <div className="mt-5 mb-3 row align-items-center ">
              <div className="col-9">
                <div className="d-flex justify-content-start gap-2">
                  <h3>{selectedGroup?.groupName}</h3>{" "}
                  <button
                    type="button"
                    class="d-flex flex-row flex-nowrap  gap-1 align-items-center w-auto btn btn-light px-4 py-2 btn btn-primary btn-sm"
                    onClick={() =>
                      navigate("/groupupdate", {
                        state: { user: state.selectedGroup },
                      })
                    }
                  >
                    <span class="d-flex">
                      <svg
                        stroke="rgba(227, 236, 237, 1)"
                        fill="rgba(47, 156, 149, 1)"
                        stroke-width="0"
                        viewBox="0 0 24 24"
                        height="1em"
                        width="1em"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path d="M9.24264 18.9964H21V20.9964H3V16.7538L12.8995 6.85431L17.1421 11.0969L9.24264 18.9964ZM14.3137 5.44009L16.435 3.31877C16.8256 2.92825 17.4587 2.92825 17.8492 3.31877L20.6777 6.1472C21.0682 6.53772 21.0682 7.17089 20.6777 7.56141L18.5563 9.68273L14.3137 5.44009Z"></path>
                      </svg>{" "}
                    </span>
                    <span class=""> </span>
                  </button>
                </div>
                <p className="resFont">
                  View your groups, patient information and catch up with
                  patients here.
                </p>
              </div>

              <div className="col-3 text-end">
                <GroupActivityButton
                  width="auto"
                  borderRadius="8px"
                  padding="5px 20px"
                  backgroundColor="rgba(31, 126, 120, 1)"
                  border="3px solid rgba(31, 126, 120, 1)"
                  color="white"
                  onClick={() => navigate("/groupadd")}
                >
                  {" "}
                  <FiPlusCircle className="mb-1" size={"20px"} /> Create New
                  Group{" "}
                </GroupActivityButton>
              </div>
              <div className="row justify-content-between align-items-center ">
                {/* <div className="col-9 my-2">
                  <input
                    type="text"
                    placeholder="Search Groups"
                    className="rounded-2 px-3 py-1 border-0 "
                  />
                  <SearchIcon
                    placeholder="Search Groups"
                    type="search"
                    backgroundColor="transparent"
                    borderRadius="8px"
                    width="100%"
                  />
                </div>
                <div className="col-3 text-end mb-2">
                  <img src={filterSvg} alt="" className="pointer" />
                </div>
                <div className="col-9 my-2">
                  <a
                    href=""
                    className="text-decoration-none"
                    style={{ color: "rgba(47, 156, 149, 1)" }}
                    onClick={() =>
                      navigate("/groupupdate", {
                        state: { user: state.selectedGroup },
                      })
                    }
                  >
                    Edit
                  </a>
                </div> */}
                {/* <div className="col-3 text-end">
                  <GroupActivityButton
                    width="auto"
                    borderRadius="8px"
                    padding="5px 20px"
                    backgroundColor="rgba(31, 126, 120, 1)"
                    border="3px solid rgba(31, 126, 120, 1)"
                    color="white"
                    onClick={() => navigate("/groupadd")}
                  >
                    {" "}
                    <FiPlusCircle className="mb-1" size={"20px"} /> Create New
                    Group{" "}
                  </GroupActivityButton>
                </div> */}
              </div>
            </div>

            <div className="custom-tabs border-bottom d-flex">
              <p
                onClick={() => {
                  setListTabs((prev) => {
                    return { prev, active: true };
                  });
                }}
                className={`px-3 border-bottom py-2 tab mb-0  ${
                  listTabs.active && "active"
                }`}
              >
                Active
              </p>
            </div>
            <div class="row mt-4 px-0">
              <div className="col-md-4">
                <div className="group_backwhite px-0 m-0 py-0 h-100">
                  {selectedGroup ? (
                    <>
                      <div className="mb-2 ">
                        {/* <GroupActivitiesName
                        selectedGroup={selectedGroup}
                        posts={posts}
                        getGroupPosts={getGroupPosts}
                      /> */}
                        {/* new Component */}
                        <div
                          // key={i}
                          className="d-flex flex-column justify-content-center align-items-start border-bottom mb-3 p-2 cursor-pointer"
                          style={{
                            height: "auto",
                            width: "100%",
                            backgroundColor: "rgba(227, 236, 237, 1)",
                          }}
                        >
                          <div
                            className="d-flex justify-content-between align-items-start"
                            style={{
                              height: "auto",
                              width: "100%",
                              //   backgroundColor: "rgba(227, 236, 237, 1)",
                            }}
                          >
                            <div className="d-flex w-75 align-items-start ">
                              <img
                                src={
                                  selectedGroup?.groupImage &&
                                  selectedGroup?.groupImage
                                }
                                onError={(e) => {
                                  e.target.src =
                                    "images/defaultPlaceholder.jpg"; //replacement image imported above
                                }}
                                alt=""
                                className="object-fit-cover me-3"
                                style={{
                                  borderRadius: "50%",
                                  height: "50px",
                                  width: "50px",
                                }}
                              />

                              <div className="flex flex-column justify-content-center align-items-center ">
                                <span
                                  style={{
                                    fontSize: "0.85rem",
                                    fontWeight: "bold",
                                    maxHeight: "18px",
                                    maxWidth: "100px",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                  }}
                                >
                                  {/* {selectedGroup?.groupName.length > 10 ? selectedGroup.groupName.slice(0,10) : selectedGroup.groupName} */}
                                  {selectedGroup?.groupName}
                                </span>
                                <p
                                  style={{
                                    fontSize: "0.7rem",
                                    maxHeight: "35px",
                                    maxWidth: "150px",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                  }}
                                  className="mb-1"
                                >
                                  {selectedGroup?.description}
                                </p>
                              </div>
                            </div>
                            <div>
                              <span
                                className="pe-2"
                                style={{
                                  fontSize: "0.7rem",
                                  color: "rgba(144, 143, 143, 1)",
                                }}
                              >
                                {selectedGroup?.updatedAt
                                  ? format(
                                      new Date(selectedGroup?.updatedAt),
                                      "HH:MM"
                                    )
                                  : "not Updated"}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="mb-2 px-2">
                        <p
                          className="quick_updates3 mt-5"
                          style={{ fontSize: "1.3rem" }}
                        >
                          Care Team
                        </p>
                        {/* {isLoading ? (
                        <center>
                          <div
                            style={{
                              width: "3rem",
                              height: "3rem",
                              color: "#1f7e78",
                              top: "10px",
                              position: "relative",
                            }}
                            className="spinner-border mt-3 mb-4"
                            role="status"
                          />
                        </center>
                      ) : 
                      posts.length > 0 ? (
                        posts
                          .slice(0, 3)
                          .map((dt, i) => (
                            <QuickUpdatescard
                              key={i}
                              dt={dt}
                              getGroupPosts={getGroupPosts}
                            />
                          ))
                      ) 
                      : (
                        <div className="card mt-4 d-flex justify-content-center align-items-center p-4">
                          <p className="m-0">Add new posts...</p>
                        </div>
                      )} */}
                        {/* new Component */}

                        {careTeamList?.length > 0 ? (
                          careTeamList?.map((provider) => (
                            <ViewCareteamMemberGroup  provider={provider} />
                          ))
                        ) : (
                          <div
                            className=" position-relative"
                            style={{
                              marginTop: "80px",
                              border: "1px solid black",
                              borderRadius: "20px",
                            }}
                          >
                            <div
                              className="position-relative d-flex align-items-end justify-content-between"
                              style={{
                                height: "200px",
                                width: "95%",
                                borderRadius: "20px",
                                top: "-10px",
                                left: "10px",
                                backgroundColor: "rgba(47, 156, 149, 1)",
                                color: "white",
                              }}
                            >
                              <p
                                className="p-2 mb-4"
                                style={{ fontSize: "0.9rem", width: "30%" }}
                              >
                                Click on any group to resume conversations
                              </p>
                              <img
                                src={GroupActivity}
                                alt="hello"
                                className="position-relative ps-1"
                                style={{
                                  bottom: "20px",
                                  height: "130%",
                                  width: "70%",
                                  right: "0px",
                                }}
                              />
                            </div>
                          </div>
                        )}
                      </div>
                    </>
                  ) : null}
                </div>
              </div>
              <div className="col-md-8 d-flex flex-column">
                <div className="row">
                  {/* <GroupActivitiesTopCard
                    heading={selectedGroup?.groupMembers?.length}
                    paragarph={"members"}
                    backColor={"#D6B86B"}
                  /> */}
                  {/* new Component */}
                  <GroupActivitiesCard
                    heading={selectedGroup?.groupMembers?.length}
                    paragarph={"member"}
                    backColor={"#D6B86B"}
                    selectedGroup={selectedGroup}
                  />{" "}
                  <GroupActivitiesCard
                    heading={selectedGroup?.visits?.reduce(
                      (acc, curr) => acc + curr.visit?.length,
                      0
                    )}
                    paragarph={"Total Visits"}
                    backColor={"#7A9BCC"}
                  />
                  <GroupActivitiesCard
                    heading={`${(
                      (selectedGroup?.activity?.reduce(
                        (acc, curr) => acc + curr.time?.length,
                        0
                      ) /
                        selectedGroup?.visits?.reduce(
                          (acc, curr) => acc + curr.visit?.length,
                          0
                        )) *
                      100
                    ).toFixed(2)}`}
                    childeren="%"
                    paragarph={"Engagement"}
                    backColor={"#C53245"}
                  />
                </div>

                <div className="row mt-4">
                  <div className="col-md-5">
                    <div className="group_backwhite h-100">
                      <div className="groupname">
                        <p className="name">group overview</p>

                        <div className="p-2 h-auto">
                          {Object?.keys(selectedGroup ? selectedGroup : {})
                            ?.length > 0 ? (
                            <Doughnut data={data()} options={doughOptions} />
                          ) : (
                            <Doughnut data={data()} options={doughOptions} />
                          )}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-md-7">
                    <div
                      className="group_backwhite h-100"
                      style={{ height: "324px" }}
                    >
                      <div className="groupname">
                        <p className="name mb-4">Health Risk Summary</p>
                        <div
                          style={{
                            height: "260px",
                            padding: "10px",
                          }}
                        >
                          <Line
                            data={dataLine()}
                            height={"100%"}
                            options={{ maintainAspectRatio: false }}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="row mt-4">
                  <div className="col-12">
                    <GroupActivityButtonList selectedgroup={selectedGroup} />
                  </div>
                </div>

                {/* <div className="group_backwhite mt-4 p-4 flex-fill">
                  <h5 className="name">Care Team</h5>

                  <div className="row">
                    <div className="col-sm-3 px-0 text-center">
                      <div className="shadow-sm rounded px-3 m-2 py-2">
                        <img
                          src="images/profile.png"
                          width="100%"
                          className="rounded-circle mb-2"
                          alt=""
                        />
                        <p className="resFont">Angela Smith</p>
                      </div>
                    </div>

                    <div className="col-sm-3 px-0 text-center">
                      <div className="shadow-sm rounded px-3 m-2 py-2">
                        <img
                          src="images/profile.png"
                          width="100%"
                          className="rounded-circle mb-2"
                          alt=""
                        />
                        <p className="resFont">Angela Smith</p>
                      </div>
                    </div>

                    <div className="col-sm-3 px-0 text-center">
                      <div className="shadow-sm rounded px-3 m-2 py-2">
                        <img
                          src="images/profile.png"
                          width="100%"
                          className="rounded-circle mb-2"
                          alt=""
                        />
                        <p className="resFont">Angela Smith</p>
                      </div>
                    </div>

                    <div className="col-sm-3 px-0 text-center">
                      <div className="shadow-sm rounded px-3 m-2 py-2">
                        <img
                          src="images/profile.png"
                          width="100%"
                          className="rounded-circle mb-2"
                          alt=""
                        />
                        <p className="resFont">Angela Smith</p>
                      </div>
                    </div>

                    <div className="col-sm-3 px-0 text-center">
                      <div className="shadow-sm rounded px-3 m-2 py-2">
                        <img
                          src="images/profile.png"
                          width="100%"
                          className="rounded-circle mb-2"
                          alt=""
                        />
                        <p className="resFont">Angela Smith</p>
                      </div>
                    </div>
                  </div>
                </div> */}
                <PostSection
                  posts={posts}
                  getGroupPosts={getGroupPosts}
                  selectedGroup={selectedGroup}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <AddPostModal
        gname={state?.selectedGroup?.groupName}
        gid={state?.selectedGroup?._id}
        show={modalShow}
        getGroupPosts={getGroupPosts}
        onHide={() => setModalShow(false)}
      />
      <AddMemberModal
        addMember={updateGroup}
        members={selectedGroup?.groupMembers}
        setMembers={setSelectedGroupMembers}
      />
    </>
  );
};

export default ViewGroupDetails;
